(function () {
  /*
   * Priority shipping toggle for the AMP Slide Cart.
   * One toggle per config: BBB_CART_PRIO_CONFIG (control) and, while an A/B test runs,
   * BBB_CART_PRIO_CONFIG_B (variation). Each one renders into its own mount and adds
   * its own variant to the cart. Which one is visible is decided by CSS only.
   */
  var CONFIGS = [window.BBB_CART_PRIO_CONFIG, window.BBB_CART_PRIO_CONFIG_B].filter(Boolean);
  if (!CONFIGS.length) return;

  var DEFAULT_MOUNT_ID = 'bbb-cart-prio-mount';

  function findLine(cart, variantId) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === Number(variantId)) return cart.items[i];
    }
    return null;
  }

  function getCart() {
    if (typeof window.SLIDECART_STATE === 'function') {
      try {
        var st = window.SLIDECART_STATE();
        if (st && st.cart) return Promise.resolve(st.cart);
      } catch (e) {}
    }
    return fetch('/cart.js').then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    });
  }

  function setToggleOn(toggle, isOn) {
    if (!toggle) return;
    if (isOn) toggle.classList.add('is-on');
    else toggle.classList.remove('is-on');
    toggle.setAttribute('aria-checked', isOn ? 'true' : 'false');
  }

  function textOr(value, fallback) {
    if (value == null) return fallback;
    var text = String(value).trim();
    return text ? text : fallback;
  }

  /** Subtitle by German local time (Europe/Berlin). */
  function getPrioSubtitle(CFG) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      weekday: 'short',
      hour: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var weekday = '';
    var hour = 0;
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'weekday') weekday = parts[i].value;
      if (parts[i].type === 'hour') hour = parseInt(parts[i].value, 10);
    }

    var cutoff = Number(CFG.cutoffHour);
    if (isNaN(cutoff)) cutoff = 13;
    var afterCutoff = hour >= cutoff;
    var isWeekend = weekday === 'Sat' || weekday === 'Sun';
    var afterFridayCutoff = weekday === 'Fri' && afterCutoff;
    var today = textOr(CFG.subtitleToday, 'Bis 13 Uhr: Garantierter Versand noch heute');
    var tomorrow = textOr(CFG.subtitleTomorrow, 'Bestellung wird morgen priorisiert versendet.');
    var monday = textOr(CFG.subtitleMonday, 'Deine Bestellung wird Montag direkt priorisiert versendet.');

    if (isWeekend || afterFridayCutoff) return monday;
    if (afterCutoff) return tomorrow;
    return today;
  }

  function createToggle(CFG) {
    var mountId = CFG.mountId || DEFAULT_MOUNT_ID;
    var state = { requestInFlight: false, optimisticOn: null };

    function findMount() {
      return document.getElementById(mountId);
    }

    function ensureMount() {
      var mount = findMount();
      if (mount) return mount;
      mount = document.createElement('div');
      mount.id = mountId;

      // The variation toggle sits right below the control toggle.
      var after = CFG.afterMountId ? document.getElementById(CFG.afterMountId) : null;
      if (after && after.parentNode) {
        after.parentNode.insertBefore(mount, after.nextSibling);
        return mount;
      }

      var footer =
        document.querySelector('#slidecarthq footer.footer') ||
        document.querySelector('#slidecarthq footer') ||
        document.querySelector('#slidecarthq .footer');
      if (!footer || !footer.parentNode) return null;
      footer.parentNode.insertBefore(mount, footer);
      return mount;
    }

    function isMissing() {
      var mount = findMount();
      return !mount || !mount.querySelector('[data-bbb-cart-prio]');
    }

    function render(cart) {
      var mount = ensureMount();
      if (!mount || !document.getElementById('slidecarthq')) return false;

      var line = findLine(cart, CFG.variantId);
      var on = state.optimisticOn !== null ? state.optimisticOn : !!line;
      var img = CFG.image || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;

      mount.innerHTML =
        '<div class="bbb-cart-prio' +
        (state.requestInFlight ? ' is-loading' : '') +
        '" data-bbb-cart-prio data-variant-id="' +
        CFG.variantId +
        '" data-line-key="' +
        (line && line.key ? line.key : '') +
        '"><div class="bbb-cart-prio__inner"><div class="bbb-cart-prio__left">' +
        '<div class="bbb-cart-prio__icon">' +
        (img
          ? '<img class="bbb-cart-prio__icon-img" src="' + img + '" width="21" height="21" alt="">'
          : '') +
        '</div><div class="bbb-cart-prio__content">' +
        '<p class="bbb-cart-prio__title"></p><p class="bbb-cart-prio__subtitle"></p>' +
        '</div></div><div class="bbb-cart-prio__right"><span class="bbb-cart-prio__price"></span>' +
        '<button type="button" class="bbb-cart-prio__toggle' +
        (on ? ' is-on' : '') +
        '" role="switch" aria-checked="' +
        (on ? 'true' : 'false') +
        '" aria-label="' +
        String(CFG.title).replace(/"/g, '&quot;') +
        '"><span class="bbb-cart-prio__toggle-track" aria-hidden="true"><span class="bbb-cart-prio__toggle-knob"></span></span></button>' +
        '</div></div></div>';

      mount.querySelector('.bbb-cart-prio__title').textContent = CFG.title;
      mount.querySelector('.bbb-cart-prio__subtitle').textContent = getPrioSubtitle(CFG);
      mount.querySelector('.bbb-cart-prio__price').textContent = CFG.price;

      var block = mount.querySelector('[data-bbb-cart-prio]');
      var toggle = mount.querySelector('.bbb-cart-prio__toggle');

      if (toggle && toggle.getAttribute('data-bound') !== 'true') {
        toggle.setAttribute('data-bound', 'true');
        if (state.requestInFlight) toggle.disabled = true;
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (state.requestInFlight || block.classList.contains('is-loading') || toggle.disabled) return;

          var turningOn = !toggle.classList.contains('is-on');
          var prevKey = block.getAttribute('data-line-key') || '';

          state.requestInFlight = true;
          state.optimisticOn = turningOn;
          setToggleOn(toggle, turningOn);
          block.classList.add('is-loading');
          toggle.disabled = true;

          var req = turningOn
            ? cartRequest('/cart/add.js', { id: CFG.variantId, quantity: 1 })
            : cartRequest('/cart/change.js', {
                id: prevKey || CFG.variantId,
                quantity: 0
              });
          req
            .then(function (data) {
              if (turningOn && data) {
                var added =
                  data.key || (data.items && data.items[0] && data.items[0].key) || '';
                if (added) block.setAttribute('data-line-key', added);
                else if (data.items) {
                  var found = findLine(data, CFG.variantId);
                  if (found && found.key) block.setAttribute('data-line-key', found.key);
                }
              }
              if (!turningOn) block.setAttribute('data-line-key', '');
              state.requestInFlight = false;
              state.optimisticOn = null;
              block.classList.remove('is-loading');
              toggle.disabled = false;
              if (typeof window.SLIDECART_UPDATE === 'function') {
                window.SLIDECART_UPDATE(refresh);
              } else {
                refresh();
              }
            })
            .catch(function (err) {
              console.error('[bbb-cart-prio]', err);
              state.requestInFlight = false;
              state.optimisticOn = null;
              setToggleOn(toggle, !turningOn);
              block.setAttribute('data-line-key', prevKey);
              block.classList.remove('is-loading');
              toggle.disabled = false;
            });
        });
      }
      return true;
    }

    return { state: state, render: render, isMissing: isMissing };
  }

  // Control first, so the variation mount can be placed right after it.
  var toggles = CONFIGS.map(createToggle);

  function renderAll(cart) {
    for (var i = 0; i < toggles.length; i++) {
      if (!toggles[i].state.requestInFlight) toggles[i].render(cart);
    }
  }

  function refresh() {
    getCart()
      .then(renderAll)
      .catch(function () {
        renderAll(null);
      });
  }

  function anyMissing() {
    if (!document.getElementById('slidecarthq')) return false;
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].isMissing()) return true;
    }
    return false;
  }

  function wrap(name) {
    var prev = window[name];
    if (prev && prev.__bbbPrio) return;
    var wrapped = function () {
      if (typeof prev === 'function' && !prev.__bbbPrio) {
        try {
          prev.apply(this, arguments);
        } catch (e) {}
      }
      setTimeout(refresh, 0);
      setTimeout(refresh, 100);
      setTimeout(refresh, 400);
    };
    wrapped.__bbbPrio = true;
    window[name] = wrapped;
  }

  function start() {
    wrap('SLIDECART_LOADED');
    wrap('SLIDECART_UPDATED');
    wrap('SLIDECART_OPENED');
    refresh();
    new MutationObserver(function () {
      if (anyMissing()) refresh();
    }).observe(document.documentElement, { childList: true, subtree: true });
    setInterval(function () {
      wrap('SLIDECART_LOADED');
      wrap('SLIDECART_UPDATED');
      wrap('SLIDECART_OPENED');
      if (anyMissing()) refresh();
    }, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
